import Module from '../../../../../layout/Module'
import TabsLink from '../../../../../tabs/TabsLink'
import { Routes, Route, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Status from './Status/Status'
import BasicInformation from './BasicInformation/BasicInformation'
import UnitOfLearning from './UnitOfLearning/UnitOfLearning'
import { useState } from 'react'
import DialogAction from './Dialog'
import { updateSkip } from '../../../../../../store/actions/datatable.actions'
import Results from './Results/Results'
import Marking from './Marking/Marking'

const Setting = () => {
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))
  const { code, studentId } = useParams()
  const basePath = `/dashboard/${studentId ? `${studentId}/` : ''}analytics/${code}/analytics-curriculum`

  const dispatch = useDispatch()
  const [modal, setModal] = useState({ show: false, type: '', formData: {} })

  const onApply = () => {
    setModal({ show: false, type: '', formData: {} })
    dispatch(updateSkip('ul', 0))
  }

  return (
    <>
      <Module.BodyHeader>
        {!roles.some((r) => ['Student', 'Parent'].includes(r)) && (
          <div className='relative overflow-hidden w-full h-full flex items-end'>
            <TabsLink
              id='school'
              items={[
                {
                  id: 'basic-info',
                  name: 'basic information',
                  path: `${basePath}/setting`,
                  permission: true,
                  end: true
                },
                {
                  id: 'unit-of-learning',
                  name: 'unit of learning',
                  path: `${basePath}/setting/unit-of-learning`,
                  permission: true,
                  end: true
                },
                {
                  id: 'status',
                  name: 'status',
                  path: `${basePath}/setting/status`,
                  permission: true,
                  end: true
                },

                {
                  id: 'marking',
                  name: 'marking',
                  path: `${basePath}/setting/marking`,
                  permission: true,
                  end: true
                },
                {
                  id: 'results',
                  name: 'results',
                  path: `${basePath}/setting/results`,
                  permission: true,
                  end: true
                }
              ]}
            />
          </div>
        )}
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        <Routes>
          <Route index element={<BasicInformation setModal={setModal} />} />
          <Route path='unit-of-learning' element={<UnitOfLearning setModal={setModal} />} />
          <Route path='status' element={<Status />} />
          <Route path='results' element={<Results />} />
          <Route path='marking' element={<Marking />} />
        </Routes>
      </Module.BodyContainer>
      {modal.show && (
        <DialogAction
          show={modal.show}
          type={modal.type}
          formData={modal.formData}
          onApply={onApply}
          onClose={() => setModal({ show: false, type: '', formData: {} })}
        />
      )}
    </>
  )
}

export default Setting
